import * as React from 'react';
import ReactDOM from 'react-dom';
import invariant from 'invariant';

import FloatingBoxes from 'components/FloatingBoxes';

let floatingBoxesRoot: HTMLElement;

if (typeof window !== 'undefined') {
  floatingBoxesRoot = document.createElement('div');
  window.document.body.appendChild(floatingBoxesRoot);
}

type Props = {};

class FloatingBoxesNode extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    invariant(
      floatingBoxesRoot,
      'floatingBoxesRoot missing in FloatingBoxesNode componentDidMount'
    );
    invariant(this.el, 'element missing in FloatingBoxesNode componentDidMount');
    floatingBoxesRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    invariant(
      floatingBoxesRoot,
      'floatingBoxesRoot missing in FloatingBoxesNode componentWillUnmount'
    );
    invariant(this.el, 'element missing in FloatingBoxesNode componentWillUnmount');
    floatingBoxesRoot.removeChild(this.el);
  }

  el: Element;

  render() {
    invariant(this.el, 'element missing in FloatingBoxesNode render');
    return ReactDOM.createPortal(<FloatingBoxes />, this.el);
  }
}

export default FloatingBoxesNode;
